export const ROLE_PERMISSION_FALLBACK = {
  administrator: [
    'clients_view_all', 'clients_create', 'clients_edit_all', 'clients_delete_all',
    'orders_view_all', 'orders_create', 'orders_edit_all', 'orders_delete_all', 'orders_continue',
    'page_clients_view', 'page_orders_view', 'page_employees_view', 'page_reviews_view',
    'page_import_export_view', 'page_devices_view', 'page_users_view', 'page_warehouse_view', 'page_settings_view',
    'warehouse_view', 'warehouse_manage',
    'warehouse_items_view', 'warehouse_items_create', 'warehouse_items_edit', 'warehouse_items_delete',
    'files_manage',
    'users_view', 'users_manage', 'users_permissions_manage',
    'import_manage',
    'settings_manage',
  ],
  koordynator: [
    'clients_view_all', 'clients_create', 'clients_edit_all',
    'orders_view_all', 'orders_create', 'orders_edit_all', 'orders_continue',
    'page_clients_view', 'page_orders_view',
    'warehouse_view',
    'page_warehouse_view', 'warehouse_items_view',
    'files_manage',
    'users_view',
    'page_employees_view',
  ],
  manager: [
    'clients_view_all', 'clients_create', 'clients_edit_all',
    'orders_view_all', 'orders_create', 'orders_edit_all', 'orders_continue',
    'page_clients_view', 'page_orders_view',
    'warehouse_view',
    'page_warehouse_view', 'warehouse_items_view',
    'files_manage',
    'users_view',
    'page_employees_view',
  ],
  technik: [
    'clients_view_own', 'orders_view_own', 'orders_edit_own', 'warehouse_view',
    'page_clients_view', 'page_orders_view',
    'page_warehouse_view', 'warehouse_items_view',
  ],
  pomocnik: ['orders_view_own', 'page_orders_view'],
};

const ORDER_STATUS_SLUG_MAP = {
  'Nowe': 'nowe',
  'W realizacji': 'w_realizacji',
  'Zrealizowane': 'zrealizowane',
  'Rozliczone': 'rozliczone',
  'Anulowane': 'anulowane',
  'Kontynuacja': 'kontynuacja',
};

const IMPLIED_PERMISSIONS = {
  users_manage: ['users_view', 'users_permissions_manage'],
  warehouse_manage: ['warehouse_view', 'warehouse_items_view', 'warehouse_items_create', 'warehouse_items_edit', 'warehouse_items_delete'],
  clients_manage: ['clients_view_all', 'clients_create', 'clients_edit_all', 'clients_delete_all'],
  clients_view: ['clients_view_all'],
  warehouse_settings: ['settings_manage'],
};

function expandPermissions(basePermissions = []) {
  const expanded = new Set(basePermissions);
  const queue = [...expanded];

  while (queue.length > 0) {
    const current = queue.shift();
    const implied = IMPLIED_PERMISSIONS[current] || [];
    for (const permission of implied) {
      if (!expanded.has(permission)) {
        expanded.add(permission);
        queue.push(permission);
      }
    }
  }

  return Array.from(expanded);
}

export function getOrderStatusPermission(status, action) {
  const slug = ORDER_STATUS_SLUG_MAP[status];
  if (!slug) return null;
  return `orders_status_${slug}_${action}`;
}

export function normalizePermissions(userLike) {
  if (!userLike) return [];
  if (Array.isArray(userLike.permissions)) {
    return expandPermissions(userLike.permissions.filter(Boolean));
  }
  return [];
}

export function hasPermission(userLike, permission) {
  return normalizePermissions(userLike).includes(permission);
}

export function hasAnyPermission(userLike, permissions = []) {
  if (!permissions?.length) return true;
  const current = normalizePermissions(userLike);
  return permissions.some((p) => current.includes(p));
}

export function hasOrderStatusPermission(userLike, action, status) {
  if (!status) return true;
  const current = normalizePermissions(userLike);
  const scoped = getOrderStatusPermission(status, action);
  if (!scoped) return true;

  const anyScopedForAction = current.some((permission) =>
    permission.startsWith('orders_status_') && permission.endsWith(`_${action}`)
  );

  if (!anyScopedForAction) return true;
  return current.includes(scoped);
}
